import { render, staticRenderFns } from "./SingleValuesCompare.vue?vue&type=template&id=72739d54&scoped=true"
import script from "./SingleValuesCompare.vue?vue&type=script&lang=js"
export * from "./SingleValuesCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72739d54",
  null
  
)

export default component.exports